import { useMutation } from "@tanstack/react-query";
import { containCountUpdateAll } from "common/api/asocijator/character/character_edit_api";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";
import toast from "react-hot-toast";

type UseContainCountUpdateAllParams = {
  invalidateKeys?: string[];
  invalidateKeysArray?: string[][];
};

export const useContainCountUpdateAll = (
  hookParams?: UseContainCountUpdateAllParams
) => {
  const { invalidateQueriesByKeys, invalidateQueriesArraysByKeys } =
    useInvalidateQueryByKeys();
  const { mutate: containCountUpdateAllMutate } = useMutation({
    mutationFn: async () => await containCountUpdateAll(),
    onSuccess: () => {
      toast.success("Contain count updated for all characters");
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      } else if (hookParams?.invalidateKeysArray) {
        invalidateQueriesArraysByKeys(hookParams.invalidateKeysArray);
      }
    },
  });

  return { containCountUpdateAllMutate };
};
